import React, { useEffect } from 'react';
import { ResponsiveModal } from 'components/Modals/ResponsiveModal';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { TextBox } from 'components/form/TextBox/TextBox';
import Label from 'components/form/Label/Label';
import { Button } from 'components/form/Button/Button';
import { stateList } from 'helpers/address.helper';
import './OneClickApplicationPersonalInfoModal.scss';
import { useAddressForm } from 'hook/addressForm.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { validateEmail } from 'helpers/signup.helpers';
import { useComplexState } from 'hook/helper.hook';
import AddressFormOneClickApplication from './components/AddressFormOneClickApplication';
import NameFormOneClickApplication from './components/NameFormOneClickApplication';
import { useViewModal } from 'hook/helper.hook';

const OneClickApplicationPersonalInfoModal = props => {
  const { visible, eventHandler, onCloseClick, personalInfo, setPersonalInfo } =
    props;

  const getStateDisplay = () => {
    let states = [];
    for (const property in stateList) {
      states.push(stateList[property].name);
    }
    return states;
  };

  let states = getStateDisplay();

  return (
    <ResponsiveModal
      visible={visible}
      centered={true}
      width="743px"
      wrapClassName={`offerDetailsContainer`}
      closable={true}
      onCancel={onCloseClick}
      showBackArrow={false}
      footer={null}
    >
      <PersonalInformationBlock
        states={states}
        personalInfo={personalInfo}
        setPersonalInfo={setPersonalInfo}
        onCloseClick={onCloseClick}
        eventHandler={eventHandler}
      />
    </ResponsiveModal>
  );
};

export const PersonalInformationBlock = props => {
  const { states, personalInfo, setPersonalInfo, onCloseClick, eventHandler } =
    props;

  useViewModal({
    'Pop Up Name': 'Hosted App Edit Info',
  });

  const addressForm = useAddressForm(personalInfo?.primaryAddress, false, true);

  const [nameState, setNameState] = useComplexState({
    firstName: personalInfo?.firstName,
    firstNameError: false,
    lastName: personalInfo?.lastName,
    lastNameError: false,
    middleInitial: personalInfo?.middleName,
    middleInitialError: false,
  });

  const [emailState, setEmailState] = useComplexState({
    email: personalInfo.email,
    emailError: false,
  });

  const isSaveDisable =
    nameState?.firstNameError ||
    nameState?.lastNameError ||
    addressForm?.streetError ||
    addressForm?.cityError ||
    addressForm?.stateError ||
    addressForm?.streetError ||
    addressForm?.zipError ||
    emailState?.emailError;

  return (
    <FlexContainer className="flex-column width100 m-margl0 margB30">
      <Label typeHeader={'h4'} className="H4 mH5 margB22">
        Edit Details
      </Label>

      <FlexContainer className="flex-column margTop8 width100 gap-16">
        <NameFormOneClickApplication
          nameState={nameState}
          setNameState={setNameState}
        />

        <AddressFormOneClickApplication
          addressForm={addressForm}
          states={states}
        />
        <EmailForm emailState={emailState} setEmailState={setEmailState} />

        <FlexContainer className="m-flex-column margT30 width100 align-items-center gap-16">
          <Button
            mrphType="standardBlue"
            datatestid={`userReviewSubmit`}
            className="m-text16 modalSubmitButton d-hide"
            onClick={onCloseClick}
          >
            <Label>Cancel</Label>
          </Button>
          <Label className="m-hide " onClick={onCloseClick}>
            <span className="otherLink text-14 fontBlue100">Cancel</span>
          </Label>
          <Button
            mrphType="primary"
            datatestid={`userReviewSubmit`}
            className="text-14 m-text16 modalSubmitButton"
            onClick={e => {
              eventHandler(CLICK, {
                'Click Type': 'Update',
                'Pop Up Name': 'Hosted App Edit Info',
              });

              setPersonalInfo(
                e,
                Object.assign(personalInfo, {
                  email: emailState.email,
                  firstName: nameState.firstName,
                  lastName: nameState.lastName,
                  middleName: nameState.middleInitial,
                  primaryAddress: {
                    street: addressForm.street,
                    city: addressForm.city,
                    state: addressForm.state,
                    zip: addressForm.zip,
                  },
                }),
              );
              onCloseClick();
            }}
            disable={isSaveDisable}
          >
            <Label className="d-hide">Save</Label>
            <Label className="m-hide">Save Changes</Label>
          </Button>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

const EmailForm = props => {
  const { emailState, setEmailState } = props;

  useEffect(() => {
    const emailError = validateEmail(emailState?.email);
    setEmailState({
      emailError,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailState?.email]);

  return (
    <FlexContainer className="flex-column">
      <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16 m-hide">
        Email
      </Label>
      <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16 d-hide">
        Email Address
      </Label>
      <FlexContainer className={'flex-column'}>
        <TextBox
          id="Email"
          name="Email"
          datatestid="Email"
          placeholder="Email"
          value={emailState?.email}
          fullWidth={true}
          error={emailState?.emailError}
          onChange={e => setEmailState({ email: e.target.value })}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default OneClickApplicationPersonalInfoModal;
